import { Lap } from '../types/stopwatch';
import { WorkoutLap } from '../types/workout';

/**
 * Convert a timer Lap object to a WorkoutLap object suitable for storage.
 */
export const convertLapToWorkoutLap = (lap: Lap): WorkoutLap => {
  // Placeholder for pace calculation if needed

  return {
    id: lap.id, // Lap.id is string
    number: lap.number,
    time: lap.time,
    cumulativeTime: lap.cumulativeTime ?? 0, // Handle potential undefined, default to 0
    totalTime: lap.cumulativeTime ?? 0, // Copy cumulativeTime to totalTime for consistency
    timestamp: lap.timestamp ? new Date(lap.timestamp).toISOString() : undefined, // Convert number to ISO string, handle undefined
    pace: lap.pace ?? undefined, // Preserve any existing pace value
    isFinalLap: !lap.isActive,
  };
};
